import { REVOKE_USER_TOKEN_MESSAGE } from './actionTypes';
import { takeEvery } from 'redux-saga/effects';
import { RealtimeMessage } from '../../entities/RealtimeMessages';
import { MessageBox, MessageBoxButtons } from '../..';
import { findMessage } from '@bimser/components';
import { safeRedirect } from '@bimser/core';

export default function* watchRevokeUserToken() {
	yield takeEvery(REVOKE_USER_TOKEN_MESSAGE, revokeUserToken);
}

function* revokeUserToken(action: RealtimeMessage<typeof REVOKE_USER_TOKEN_MESSAGE>) {
	const token = sessionStorage.getItem('token') ?? localStorage.getItem('token');
	if (token) {
		yield MessageBox.warning({
			title: findMessage.get('101362'),
			content: findMessage.get('101363'),
			buttons: MessageBoxButtons.OK,
			showErrorDetail: false
		});

		window.setTimeout(() => {
			localStorage.removeItem('token');
			sessionStorage.removeItem('token');

			const loginMethod = localStorage.getItem('loginMethod');
			const logoutUrl = localStorage.getItem('externalAccountLogoutUrl');
			if (loginMethod === 'externalAccounts' && logoutUrl) {
				safeRedirect(logoutUrl);
				localStorage.removeItem('loginMethod');
				localStorage.removeItem('externalAccountLogoutUrl');
			} else {
				const externalLoginUrl = sessionStorage.getItem('externalLoginUrl');

				if (externalLoginUrl) {
					safeRedirect(externalLoginUrl);
					sessionStorage.removeItem('externalLoginUrl');
				} else {
					window.location.hash = '';
					window.location.reload();
				}
			}
		}, 100);
	}
}
